import { BANK } from "../constants";
import { apiSlice } from "./apiSlice";

const bankApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBanksList: builder.query({
      query: ({ name = "", page = 1 }) => {
        let url = `${BANK}?per_page=15`;
        if (name) {
          url += `&name=${name}`;
        }
        if (page) {
          url += `&page=${page}`;
        }
        return url;
      },
      providesTags: "banks",
    }),

    createBank: builder.mutation({
      query: ({ formData }) => ({
        url: BANK,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["banks"],
    }),

    updateBank: builder.mutation({
      query: ({ formData, id }) => ({
        url: `${BANK}/${id}`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["banks"],
    }),
  }),
});

export const {
  useGetBanksListQuery,
  useCreateBankMutation,
  useUpdateBankMutation,
} = bankApiSlice;
